import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-1 label--text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_AppSection = _resolveComponent("AppSection")!

  return (_openBlock(), _createBlock(_component_AppSection, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref: "formRef",
        model: _ctx.form,
        rules: _ctx.rules,
        class: "text-left"
      }, {
        default: _withCtx(() => [
          (_ctx.form.licenseKey != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "mb-1 label--text" }, "License key", -1)),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.form.licenseKey), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "mb-1 label--text" }, "Organization name", -1)),
          _createVNode(_component_el_form_item, { prop: "organizationName" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.organizationName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.organizationName) = $event)),
                placeholder: "Organization name"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "mb-1 label--text" }, "Max Api access per organization", -1)),
          _createVNode(_component_el_form_item, { prop: "maxNumberOfAccessedApisPerOrganization" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input_number, {
                modelValue: _ctx.form.maxNumberOfAccessedApisPerOrganization,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.maxNumberOfAccessedApisPerOrganization) = $event)),
                min: -1,
                max: 2147483647,
                "controls-position": "right"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "mb-1 label--text" }, " Max files size per organization (GB) ", -1)),
          _createVNode(_component_el_form_item, { prop: "maxFilesSizePerOrganization" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input_number, {
                modelValue: _ctx.form.maxFilesSizePerOrganization,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.maxFilesSizePerOrganization) = $event)),
                min: -1,
                max: 2147483647,
                "controls-position": "right"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _cache[25] || (_cache[25] = _createElementVNode("div", { class: "mb-1 label--text" }, "Max number of eP2AS-Vue users", -1)),
          _createVNode(_component_el_form_item, { prop: "maxNumberOfEp2asVueUsers" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input_number, {
                modelValue: _ctx.form.maxNumberOfEp2asVueUsers,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.maxNumberOfEp2asVueUsers) = $event)),
                min: -1,
                max: 2147483647,
                "controls-position": "right"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _cache[26] || (_cache[26] = _createElementVNode("div", { class: "mb-1 label--text" }, "Max number of submission units", -1)),
          _createVNode(_component_el_form_item, { prop: "maxNumberOfSubmissionUnits" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input_number, {
                modelValue: _ctx.form.maxNumberOfSubmissionUnits,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.maxNumberOfSubmissionUnits) = $event)),
                min: -1,
                max: 2147483647,
                "controls-position": "right"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _cache[27] || (_cache[27] = _createElementVNode("div", { class: "mb-1 label--text" }, "Allowed eCTD versions", -1)),
          _createVNode(_component_el_form_item, { prop: "allowedEctdVersions" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox_group, {
                modelValue: _ctx.form.allowedEctdVersions,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.allowedEctdVersions) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_checkbox, { value: "v3.2.2" }, {
                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                      _createTextVNode("v3.2.2", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_el_checkbox, { value: "v4.0" }, {
                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                      _createTextVNode("v4.0", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _cache[28] || (_cache[28] = _createElementVNode("div", { class: "mb-1 label--text" }, "Allowed remote repositories", -1)),
          _createVNode(_component_el_form_item, { prop: "allowedRemoteRepositories" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox_group, {
                modelValue: _ctx.form.allowedRemoteRepositories,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.allowedRemoteRepositories) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_checkbox, { value: "wfs_smb_v2_v3" }, {
                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                      _createTextVNode("SMB v3", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_el_checkbox, { value: "sharepoint" }, {
                    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                      _createTextVNode("Sharepoint with ACS", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_el_checkbox, { value: "sharepoint_entraid" }, {
                    default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                      _createTextVNode("Sharepoint with Entra ID", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_el_checkbox, { value: "documentum" }, {
                    default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                      _createTextVNode("Documentum", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_el_checkbox, { value: "veeva_vault" }, {
                    default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                      _createTextVNode("Veeva Vault", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_el_checkbox, { value: "agatha" }, {
                    default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                      _createTextVNode("Agatha", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_el_checkbox, { value: "s3" }, {
                    default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                      _createTextVNode("S3", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _cache[29] || (_cache[29] = _createElementVNode("div", { class: "mb-1 label--text" }, "Lease start date", -1)),
          _createVNode(_component_el_form_item, { prop: "leaseStartDate" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.form.leaseStartDate,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.leaseStartDate) = $event)),
                type: "date",
                placeholder: "Lease start date",
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _cache[30] || (_cache[30] = _createElementVNode("div", { class: "mb-1 label--text" }, "Expired date", -1)),
          _createVNode(_component_el_form_item, { prop: "expiredDate" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.form.expiredDate,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.expiredDate) = $event)),
                type: "date",
                placeholder: "Expired date",
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { prop: "isLicensed" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_switch, {
                modelValue: _ctx.form.isLicensed,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.isLicensed) = $event)),
                "active-text": "Is active"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { prop: "isAllowedWithoutLicenseKey" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_switch, {
                modelValue: _ctx.form.isAllowedWithoutLicenseKey,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.isAllowedWithoutLicenseKey) = $event)),
                "active-text": "Allowed without license key"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { class: "text-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                color: "primary",
                loading: _ctx.loading,
                onClick: _ctx.submit
              }, {
                default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                  _createTextVNode("Submit", -1)
                ]))]),
                _: 1
              }, 8, ["loading", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }))
}